export const REDIRECT_404_URL = '/404';
